<template>
  <div class="previewAccNum-page">
    <el-select v-model="l_value" @change="change" :placeholder="$t('deposit.upload.please_sel')">
      <el-option
        v-for="(item,key) in accountNumbers"
        :disabled="item.disabled"
        v-show="item.enabled == true"
        :key="key"
        :label="getKey(item.label)+(item.tradeAccountType?getKey(item.tradeAccountType):'')+$t('common.ACCOUNT')+item.value"
        :value="item.value"
      ></el-option>
    </el-select>
    <br>
    <br>
    <el-tabs v-show="account.length>0" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane name="first">
        <span :class="{'tab-title': true,'active-title': activeName=='first'}" slot="label">
          <img class="currency-icon" :src="require('@/assets/images/currency/存入港币.png')">
          &nbsp;&nbsp;{{$t('deposit.saveHK')}}
        </span>
        <bEddidBankAccountDetail
          v-for="(item,key) in account"
          :key="key"
          :currency="'HKD'"
          :accountInfo="item"
        ></bEddidBankAccountDetail>
      </el-tab-pane>
      <el-tab-pane name="second" v-if="isshow">
        <span :class="{'tab-title': true,'active-title': activeName=='second'}" slot="label">
          <img class="currency-icon" :src="require('@/assets/images/currency/存入美元.png')">
          &nbsp;&nbsp;{{$t('deposit.saveUSD')}}
        </span>
        <bEddidBankAccountDetail
          v-for="(item,key) in account_1"
          :key="key"
          :currency="'USD'"
          :accountInfo="item"
        ></bEddidBankAccountDetail>
      </el-tab-pane>
      <el-tab-pane name="third" v-if="isshow">
        <span :class="{'tab-title': true,'active-title': activeName=='third'}" slot="label">
          <img class="currency-icon" :src="require('@/assets/images/currency/存入人民币.png')">
          &nbsp;&nbsp;{{$t('deposit.saveRMB')}}
        </span>
        <bEddidBankAccountDetail
          v-for="(item,key) in account_1"
          :key="key"
          :currency="'CNY'"
          :accountInfo="item"
        ></bEddidBankAccountDetail>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import bankInfo from '@/js/bankInfo'
import _ from 'lodash'
import utils from '../util/util.js'
export default {
  props: ['isshow'],
  data () {
    return {
      accountNumbers: [],
      account: [],
      account_1: [],
      l_value: '',
      bankSubAccountList: [],
      activeName: 'first'
    }
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  async mounted () {
    const accountNumber = this.$getProfile().custom.accountNumber
    const result = await this.$api.getAcountType({
      accountNumber: accountNumber
    })
    let arr = result.data.tradeAccountList
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].enabled == true) {
        arr[i].label = arr[i].type
        arr[i].value = arr[i].tradeAccount
        arr[i].accountType = arr[i].accountType
        arr[i].tradeAccountType = arr[i].tradeAccountType
        this.accountNumbers.push(arr[i])
      }
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    },
    async getBankSubAccountList () {
      const accountNumber = this.$getProfile().custom.accountNumber
      let bankSubAccountList = await this.getBankSubAccount(accountNumber)
      const res = await utils.formatImage(bankSubAccountList)
      return res
    },
    async getBankSubAccount (accountNumber) {
      const res = await this.$api.getsubAccount({
        accountNumber: accountNumber,
        sortKey: 'createdTime',
        sortVal: '-1',
        searchParams: {
          accountNumber: this.$getProfile().custom.accountNumber,
          status: 'completed',
          isLock: true
        }
      })
      return res.data.rows
    },

    getKey (key) {
      let item = this.$t('common')
      return item[key] ? item[key] : key
    },
    async change (val) {
      for (let value of this.accountNumbers) {
        if (value.value === val) {
          let bankSubAccountList = await this.getBankSubAccountList()
          let eddidBankList = bankInfo[value.label]
          this.account = []
          this.account_1 = []
          if (this.isshow === true) {
            var tempArr = []
            for (var i = 0; i < eddidBankList.length; i++) {
              if (!eddidBankList[i].FPSName) {
                tempArr.push(eddidBankList[i])
              }
            }
            this.account = _.concat(bankSubAccountList, tempArr || [])
            this.account_1 = tempArr || []
          } else {
            this.account.push(eddidBankList[eddidBankList.length - 1])
          }
          break
        }
      }
    }
  }
}
</script>

<style lang="scss">
.previewAccNum-page {
  height: min-content;
  .currency-icon {
    vertical-align: middle;
    width: 30px;
  }
  .tab-title {
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Semibold;
  }
  .active-title {
    color: rgba(254, 192, 0, 1);
  }
  .el-select {
    width: 100%;
  }
}
</style>
